/**
 * Use with `getFormDefinitionById` for admin flows that must load schema even when the form is inactive.
 * Sends `forceResponse=1` so the API returns 200 with a body instead of 204.
 */
export const GET_FORM_DEFINITION_FORCE_RESPONSE_OPTIONS = Object.freeze({ forceResponse: true });
